import React from 'react';
import { useSelector } from 'react-redux';

import CombinedChart from './CombinedChart';
import UnifiedTabsChart from './UnifiedTabsChart';
import Skeletons from '../Skeletons';

import { filtersSelector, timeSeriesSelector, timeSeriesSettingsSelector } from '../../selectors';
import { initParams } from '../../configs';
import { isUnified } from '../../../../utils/helpers';

const { store, permissions } = initParams;

const DownloadsRevenue = () => {
  const filters = useSelector(filtersSelector);
  const timeSeries = useSelector(timeSeriesSelector);
  const { loaded, pending } = useSelector(timeSeriesSettingsSelector);

  if (pending || !loaded || !timeSeries) {
    return (
      <section
        className={`publisher_page_downloads_revenue card ${
          isUnified(store) ? 'b-t pt-xxl mb-xxl' : ''
        }`}
      >
        {Skeletons.chart}
      </section>
    );
  }

  if (permissions.prospect || permissions.isFlexUser) {
    return (
      <section className="publisher_page_downloads_revenue card p-a-md">
        <h3 className="text-md m-b-lg">Downloads / Revenue</h3>
        <div className="text-center text-xs publisher_page_downloads_revenue__blurred">
          {permissions.isFlexUser ? (
            'Not included in your plan'
          ) : (
            <>
              Publisher performance data is available&nbsp;
              <a href="/pricing">on any paid plan.</a>
            </>
          )}
        </div>
      </section>
    );
  }

  if (!permissions.allowTotals) {
    return (
      <section className="publisher_page_downloads_revenue card p-a-md">
        <h3 className="text-md m-b-lg">Downloads / Revenue</h3>
        <div className="text-center text-xxs">
          {!permissions.prospect && (
            <>
              <a href="/pricing">Upgrade</a>&nbsp;to see this data
            </>
          )}
        </div>
      </section>
    );
  }

  if (isUnified(store)) {
    return (
      <section className="publisher_page_downloads_revenue card b-t pt-xxl mb-xxl">
        <h2 className="text-md mb-sm">Downloads / Revenue</h2>
        <UnifiedTabsChart data={timeSeries} />
      </section>
    );
  }

  return (
    <section className="publisher_page_downloads_revenue card card m-b-0">
      <h3 className="text-md m-b-lg">
        Downloads / Revenue vs. {filters.period}-day Historical Average
      </h3>
      <CombinedChart data={timeSeries} />
    </section>
  );
};

export default DownloadsRevenue;
